import { sentenceCase } from 'change-case';
import { titleCase } from 'title-case';
import Quill from 'quill';
import { BlockEmbed } from 'quill/blots/block';
const Inline = Quill.import('blots/inline') as any;


function prettyCase(str: string) {
    return titleCase(sentenceCase(str));
}

function customTaxonomyModuleSearch(term: string, item: any): boolean {
    const termWords = term.toLowerCase().split(' ').filter(t => t);
    const itemLabel = item.name.toLowerCase();
    return termWords.every(word => itemLabel.includes(word));
}

class FontStyleBlot extends Inline {
  static blotName = 'font';
  static tagName = 'span';

  static create(value: string) {
    const node = super.create();
    const fontMap: { [key: string]: string } = {
      'consolas': "'Consolas', monospace",
      'serif': 'Georgia, "Times New Roman", serif',
      'sans-serif': 'Arial, Helvetica, sans-serif',
      'monospace': '"Courier New", Courier, monospace'
    };
    // This creates inline style, NOT a class
    node.style.fontFamily = fontMap[value] || fontMap['consolas'];
    return node;
  }

  static formats(node: HTMLElement) {
    return node.style.fontFamily;
  }
}

class RawHtmlBlot extends BlockEmbed {
  static override blotName = 'rawHtml';
  static override tagName = 'table';

  static override create(html: string): HTMLElement {
    const node = super.create(html) as HTMLElement;
    // super.create() produces a bare <table>; copy the source table's own
    // attributes and inner content onto it.
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const src = temp.querySelector('table');
    if (src) {
      Array.from(src.attributes).forEach(attr => node.setAttribute(attr.name, attr.value));
      node.innerHTML = src.innerHTML;
    }
    node.setAttribute('contenteditable', 'false');
    return node;
  }

  static value(node: HTMLElement): string {
    // Strip the runtime contenteditable attribute so it is not persisted.
    const clone = node.cloneNode(true) as HTMLElement;
    clone.removeAttribute('contenteditable');
    return clone.outerHTML;
  }
}

function getFlattendErrorArray(error: any): string[] {
    const messages: string[] = [];
    if (error.fields) {
      for (const field in error.fields) {
        if (error.fields.hasOwnProperty(field)) {
          messages.push(...error.fields[field]);
        }
      }
    }
    if (error.general) {
      messages.push(...error.general);
    }
    return messages;
  }

export { prettyCase, customTaxonomyModuleSearch, FontStyleBlot, RawHtmlBlot, getFlattendErrorArray };
